module.exports = __webpack_public_path__ + "a401d0659ff8ceac9f25f0ac69521650.png";